/**
 * Мост между перехватчиком 409 и React.
 *
 * Перехватчик живёт вне дерева компонентов, а диалог разрешения конфликта и тосты — внутри.
 * Провайдер (`GameDataConflictProvider`) регистрирует себя здесь при монтировании,
 * перехватчик дёргает его через этот модуль.
 */

import {
  ConflictHandler,
  ConflictRequest,
  GameDataPayload,
  MergeSpec,
} from '../../types/game-data.types';

let handler: ConflictHandler | null = null;

export const conflictBridge = {
  /** Провайдер регистрируется при монтировании; возвращённая функция снимает регистрацию. */
  register(next: ConflictHandler): () => void {
    handler = next;
    return () => {
      if (handler === next) handler = null;
    };
  },

  /** Есть ли кому показать диалог. Нет провайдера — конфликт разрешать некому. */
  isReady(): boolean {
    return handler !== null;
  },

  resolve(request: ConflictRequest): Promise<GameDataPayload | null> {
    if (!handler) return Promise.resolve(null);
    return handler.resolve(request);
  },

  notifyAutoMerged(spec: MergeSpec<unknown>): void {
    handler?.notifyAutoMerged(spec);
  },
};

export default conflictBridge;
